import { CLUSTER_API } from '../API/BASE_URL';

export const getEquipment = async () => {
  const response = await fetch(CLUSTER_API + 'room/equipment-category/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
